/**
 * Order API service
 * @module features/orders/orderService
 */

import api from '../../app/axios';

const getMyOrders = async (params) => {
  const response = await api.get('/orders', { params });
  return response.data;
};

const getOrderById = async (orderId) => {
  const response = await api.get(`/orders/${orderId}`);
  return response.data;
};

const orderService = { getMyOrders, getOrderById };
export default orderService;

// Developed and Designed by Trophy Developers
